import {CurrentModalEnum} from "./AccountInfo";
import React from "react";
import styled from "styled-components/macro";
import {PersonalInfo} from "./Modals/PersonalInfo";
import {PassportInfo} from "./Modals/PassportInfo";
import {SocialNumberInfo} from "./Modals/SocialNumberInfo";

export interface CurrentModalProps {
    currentInfoModal: CurrentModalEnum
    onGoEdit(): void
    onGoBack(): void
    onGoEditProfile(): void
}

export const InfoModalContent = ({currentInfoModal, onGoEdit, onGoBack, onGoEditProfile}: CurrentModalProps) => {

    const router = () => {
        switch (currentInfoModal) {
            case CurrentModalEnum.Personal: {
                return <PersonalInfo onGoEdit={onGoEdit} onGoBack={onGoBack}/>
            }
            case CurrentModalEnum.Passport: {
                return <PassportInfo onGoEdit={onGoEdit} onGoEditProfile={onGoEditProfile} onGoBack={onGoBack}/>
            }
            case CurrentModalEnum.SocialNumber: {
                return <SocialNumberInfo onGoEdit={onGoEdit} onGoBack={onGoBack}/>
            }
            default : {
                return <PersonalInfo onGoEdit={onGoEdit} onGoBack={onGoBack}/>
            }
        }
    }


    return <ModalContainer>
        {router()}
    </ModalContainer>
}

const ModalContainer= styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
